/**
 * Noibu Feature Flag: shorter pre-order titles on home cards
 * (flag "2083-shorter-pre-order-titles-on-home-cards", Noibu A/B test 279).
 *
 * Loaded only on the home page, by sections/noibu-preorder-titles-ab.liquid
 * (in sections/header-group.json, guarded by request.page_type == 'index').
 * A separate file on purpose: the other flag files define controls for running
 * experiments and must not change mid-flight.
 *
 *   original                    -> html.nff-pot--a  (control, the default)
 *   pre-order-tag-short-titles  -> html.nff-pot--b
 *
 * Variation B, home page only: on the product cards of the theme's own
 * featured-collection sections, a title that opens with
 * "(PRE-ORDER) <year> Hot Wheels" (with or without "1:64") is printed without
 * that opening, and a small "Pre-order <year>" tag sits above it. Other titles,
 * product data, collection pages, search, product pages and the cards inside
 * other tests' noibu_* home sections are untouched.
 *
 * The rewrite is text only: it keeps the card's link, its id and its
 * aria-labelledby, so the link's accessible name becomes the short title. The
 * full title is kept on the link in data-nff-pot-full and in a title attribute,
 * and the control restores it exactly.
 *
 * Targeting (device type "mobile", phones and tablets) lives in the Noibu
 * test. There is no CSS breakpoint here: the flag alone decides who sees B.
 *
 * Noibu's implementation code for test 279 (console > A/B tests > 279 >
 * Define variations in code), implemented faithfully below in render():
 *
 *   function renderPreOrderTagShortTitles(container) {
 *     // TODO: the implementation for variation B
 *   }
 *
 *   function renderOriginal(container) {
 *     // TODO: the implementation for the default experience
 *   }
 *
 *   function render(container) {
 *     const { variant } = client.getStringDetails(
 *       "2083-shorter-pre-order-titles-on-home-cards",
 *       "original"
 *     );
 *
 *     switch (variant) {
 *       case "pre-order-tag-short-titles":
 *         // Variation B
 *         return renderPreOrderTagShortTitles(container);
 *       case "original":
 *         // Variation A (control)
 *         // Since this is the original experience, add no code here and
 *         // let this fall through to the default.
 *       default:
 *         // This should always be the original experience. Users excluded
 *         // by targeting will see this.
 *         return renderOriginal(container);
 *     }
 *   }
 *
 *   // `client` is the ready client from the Noibu A/B testing SDK.
 *   // Call render(container) once your feature flag client is ready.
 *
 * The SDK's details object carries the arm in `variant` (and `value`); older
 * generated snippets destructured `variation`, which always fell through to the
 * control. readVariation() reads all three.
 *
 * DEPLOY BEFORE STARTING THE TEST
 * While the test is a draft the SDK serves the default, so every visitor gets
 * the control and this file is inert. Shoppers bucketed into B before this code
 * is live are counted in B while seeing A, and that data cannot be repaired.
 */
(function () {
  'use strict';

  var FLAG = '2083-shorter-pre-order-titles-on-home-cards';
  var CONTROL = 'original';
  var VARIATION_B = 'pre-order-tag-short-titles';
  var CACHE_KEY = 'nff.preorder-titles';
  var REPORT_KEY = 'nff_preorder-titles';
  var STATE_ATTR = 'data-nff-pot-state';
  var SDK_TIMEOUT_MS = 10000;

  // "(PRE-ORDER) 2027 Hot Wheels 1:64 Premium ..." -> year 2027, rest "Premium ..."
  var PREFIX = /^\s*\(PRE-ORDER\)\s*(\d{4})\s*Hot\s+Wheels\s*(?:1:64\s*)?/i;

  var CLASSES = {};
  CLASSES[CONTROL] = 'nff-pot--a';
  CLASSES[VARIATION_B] = 'nff-pot--b';

  var root = document.documentElement;

  function cardLinks() {
    var links = document.querySelectorAll('.shopify-section .card__heading a');
    var out = [];
    for (var i = 0; i < links.length; i++) {
      var section = links[i].closest('.shopify-section');
      // Leave other tests' home sections (noibu_preorders_b, noibu_paid_landing, ...) alone.
      if (!section || section.id.indexOf('__noibu_') !== -1) continue;
      out.push(links[i]);
    }
    return out;
  }

  function shorten() {
    var links = cardLinks();
    var changed = 0;
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.hasAttribute('data-nff-pot-full')) continue;
      var full = (link.textContent || '').replace(/\s+/g, ' ').trim();
      var match = full.match(PREFIX);
      if (!match) continue;
      var rest = full.replace(PREFIX, '').trim();
      if (!rest) continue;

      link.setAttribute('data-nff-pot-full', full);
      link.setAttribute('title', full);
      link.textContent = rest;

      var heading = link.closest('.card__heading') || link;
      var tag = document.createElement('span');
      tag.className = 'nff-pot-tag';
      tag.textContent = 'Pre-order ' + match[1];
      heading.parentNode.insertBefore(tag, heading);
      changed++;
    }
    return changed;
  }

  function restore() {
    var links = document.querySelectorAll('[data-nff-pot-full]');
    for (var i = 0; i < links.length; i++) {
      links[i].textContent = links[i].getAttribute('data-nff-pot-full');
      links[i].removeAttribute('data-nff-pot-full');
      links[i].removeAttribute('title');
    }
    var tags = document.querySelectorAll('.nff-pot-tag');
    for (var j = 0; j < tags.length; j++) tags[j].parentNode.removeChild(tags[j]);
  }

  function ready() {
    // Lifts the paint-time hide of card titles (see the gate section).
    root.classList.add('nff-pot-ready');
  }

  function activate(variation) {
    var className = CLASSES[variation] || CLASSES[CONTROL];
    root.classList.remove(CLASSES[CONTROL], CLASSES[VARIATION_B]);
    root.classList.add(className);
    root.setAttribute('data-nff-pot', variation);
    if (variation === VARIATION_B) shorten();
    else restore();
    ready();
    document.dispatchEvent(new CustomEvent('noibu:preorder-titles-variation', { detail: { variation: variation } }));
  }

  function reportState(state, detail) {
    root.setAttribute(STATE_ATTR, state);
    if (state === 'unavailable') {
      console.warn('[nff] ' + FLAG + ' flag unavailable, rendering control: ' + detail);
    }
    var tries = 0;
    (function attempt() {
      try {
        if (window.NOIBUJS && typeof window.NOIBUJS.addCustomAttribute === 'function') {
          window.NOIBUJS.addCustomAttribute(REPORT_KEY, state);
          return;
        }
      } catch (error) {
        /* collect-core may still be booting. */
      }
      if (++tries < 40) setTimeout(attempt, 500);
    })();
  }

  function afterLoad(callback) {
    if (document.readyState === 'complete') {
      callback();
      return;
    }
    window.addEventListener('load', function () {
      callback();
    });
  }

  function whenClientReady(onReady, onUnavailable) {
    var done = false;
    var timer = null;

    function finish(handler, argument) {
      if (done) return;
      done = true;
      if (timer !== null) clearTimeout(timer);
      handler(argument);
    }

    afterLoad(function () {
      if (done) return;
      timer = setTimeout(function () {
        finish(onUnavailable, 'no client ' + SDK_TIMEOUT_MS + 'ms after window.load');
      }, SDK_TIMEOUT_MS);
    });

    window.addEventListener('noibuFeatureFlagError', function (event) {
      var message = (event && event.detail && event.detail.message) || 'unknown error';
      finish(onUnavailable, message);
    });

    if (window.NoibuFeatureFlag) {
      try {
        var client = window.NoibuFeatureFlag.getClient();
        client.addHandler('PROVIDER_READY', function () {
          finish(onReady, client);
        });
      } catch (error) {
        finish(onUnavailable, 'getClient() threw: ' + error);
      }
      return;
    }

    window.addEventListener('noibuFeatureFlagReady', function (event) {
      var client = event && event.detail && event.detail.client;
      if (client) finish(onReady, client);
      else finish(onUnavailable, 'ready event carried no client');
    });
  }

  function remember(variation) {
    try {
      window.localStorage.setItem(CACHE_KEY, JSON.stringify({ v: variation, t: Date.now() }));
    } catch (error) {
      /* Storage unavailable (private mode, some webviews). */
    }
  }

  function forcedVariation() {
    // QA override: ?nff_preorder_titles=pre-order-tag-short-titles or =original
    try {
      var value = new URLSearchParams(window.location.search).get('nff_preorder_titles');
      if (value === CONTROL || value === VARIATION_B) return value;
    } catch (error) {
      /* URLSearchParams unavailable. */
    }
    return null;
  }

  function readVariation(client) {
    if (typeof client.getStringDetails === 'function') {
      var details = client.getStringDetails(FLAG, CONTROL) || {};
      return details.variant || details.variation || details.value || CONTROL;
    }
    return client.getStringValue(FLAG, CONTROL);
  }

  function renderPreOrderTagShortTitles() {
    activate(VARIATION_B);
    remember(VARIATION_B);
    return VARIATION_B;
  }

  function renderOriginal() {
    activate(CONTROL);
    remember(CONTROL);
    return CONTROL;
  }

  function render(client) {
    var variant = readVariation(client);
    switch (variant) {
      case VARIATION_B:
        // Variation B
        return renderPreOrderTagShortTitles();
      case CONTROL:
      // Variation A (control): falls through to the default.
      default:
        // Control, visitors excluded by targeting (desktop) and unresolved
        // flags all land here.
        return renderOriginal();
    }
  }

  // The script is deferred, so the cards are parsed. Replay the arm the gate's
  // paint-time hint chose, so a returning B visitor sees short titles at once.
  var hinted = root.getAttribute('data-nff-pot');
  if (hinted === VARIATION_B || hinted === CONTROL) activate(hinted);
  else ready();

  var forced = forcedVariation();
  if (forced) {
    // A forced preview neither caches the arm nor asks the SDK.
    activate(forced);
    root.setAttribute(STATE_ATTR, 'forced');
    return;
  }

  whenClientReady(
    function (client) {
      reportState(render(client));
      client.addHandler('PROVIDER_CONFIGURATION_CHANGED', function () {
        render(client);
      });
    },
    function (detail) {
      // Never cache a value the SDK did not produce. Keep a replayed real
      // assignment so titles do not flip back mid-visit; otherwise control.
      if (!root.hasAttribute('data-nff-pot')) activate(CONTROL);
      reportState('unavailable', detail);
    }
  );
})();
